import React, {Fragment, useState} from 'react';
import {chevronUp, chevronDown } from '../../Templates/icons'
//Should we use "primatives" terminology?
const FAQ = [
    {
        question: `What does "Decimating" mean in the Model Decimator?`,
        answer: `The term decimation is used to describe the process of removing entities, such as polygons, from a geometric representation. 
                The goal of decimation is to significantly reduce the number of primatives required to accurately model the uploaded object.`
    },
    {
        question: `Why is the "Decimation" process so important?`,
        answer: `The goal of decimation is to significantly reduce the number of primatives required to accurately model the uploaded object. 
                Doing so will not only reduce storage space required, but increase loading/rendering performance.`
    },
    {
        question: `How do I know which decimation setting to use?`,
        answer: `Choose the highest setting that still maintains an accurate representation of your model.`
    },
    {
        //CAN WE REMOVE? "I cannot only view a few components" weird wording
        question: `I cannot only view a few components, who do I need to contact about this?`,
        answer: `Contact a supervisor and make sure you have the appropriate Role to access that component.`
    },
    {
        question: `Am I able to adjust my profile information?`,
        answer: `At the moment, this must be edited by a system administrator.`
    },
    {
        question: `My Attachment appears to be failing?`,
        answer: `Please ensure it is a valid file type and that the file name is not duplicated and does not contain spaces or special characters.`
    },
    {
        //CAN WE REMOVE?
        question: `What do the symbols next to a search field mean?`,
        answer: `"Sorting Icons" allow for a list to be sorted in various ways. Sorting icons that are active will appear blue and the inactive icons will appear grey.`
    },
    {
        question: `I accidently deleted a work instruction, is there a way to recover it?`,
        answer: `Deleting a work instruction is currently an irreversible action.`
    },
    {
        question: `What extensions are supported for attachments?`,
        answer: `Images - .png, .tiff, .jpg, .jpeg; Videos - .mov, .mp4; Audio - .mp3; Others - .pdf`
    },
    {

        question: `What extensions are supported for models?`,
        answer: `Currently .obj, .fbx, and .glb files are supported for decimation and model uploading.`
    }
]

export const Accordian = () => {

    const [selectedQuestion, selectQuestion] = useState(false);

    const toggle = question => {
        if (selectedQuestion === question) {
            //if selectedQuestion question is already active, then close
            return selectQuestion(null)
        }
        selectQuestion(question)
    }
    return (
        <Fragment>
            <div className="qa-container flex-column overflow">
                <ul id="faq-list">
                    {FAQ.map(({question, answer}) => {
                        return (
                            <li key={question} id="faq-item" onClick={() => toggle(question)}>
                                <div id="accordion-question">
                                    <span className={`${selectedQuestion === question ? "underline" : ""}`}>{question}</span>
                                    <span id="chevron">{selectedQuestion === question ? chevronUp : chevronDown}</span>
                                </div>
                                {selectedQuestion === question ? <div id="accordion-answer" className="qa-answer">
                                    {selectedQuestion === question ? (
                                        <div id="dropdown" className="max-width">
                                            <p className="qa-answer">{answer}</p>
                                        </div>
                                    ) : null}
                                </div> : null}
                                {/* <div id="qa-bar"></div> */}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </Fragment>
    )
}